import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Card, Col, Container, Row } from "react-bootstrap";
import React, { Fragment, useEffect, useState } from "react";
import {
  createNewCustomer,
  fetchCustomerList,
  updateCustomer,
} from "../actions/customer";
import { useNavigate, useParams } from "react-router-dom";

import AddIcon from "@mui/icons-material/Add";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import EditIcon from "@mui/icons-material/Edit";
import InputField from "../components/Admin/Reusable/InputField";
import KeyIcon from "@mui/icons-material/Key";
import RibbonRow from "../components/RibbonRow";
import SelectStatus from "../components/Admin/Reusable/Form/SelectStatus";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import { basicFormValidationHandler } from "../utils";
import { fetchCountryFormList } from "../actions/country";
import { fetchRoleList } from "../actions/role";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import FormSystemInformation from "../components/Admin/Reusable/FormSystemInformation";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";

function generateRandomPassword() {
  const length = Math.floor(Math.random() * 3) + 13; // Dužina između 9 i 11 karaktera
  const specialChars = "-_~.#!@&";

  const allChars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789" +
    specialChars;

  const getRandomChar = (charSet) => {
    const randomIndex = Math.floor(Math.random() * charSet.length);
    return charSet.charAt(randomIndex);
  };

  let password = "";
  password += getRandomChar("ABCDEFGHIJKLMNOPQRSTUVWXYZ"); // Prvo slovo je veliko
  password += getRandomChar("0123456789"); // Barem jedan broj
  password += getRandomChar(specialChars); // Barem jedan specijalni karakter

  while (password.length < length) {
    password += getRandomChar(allChars);
  }

  return password;
}

const CustomerAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const initialState = {
    name: "",
    lastName: "",
    email: "",
    roleId: "684b1185-5baf-4d77-8f4f-f29e976264fd",
    countryId: "8ab0a601-8805-4dc4-a5e1-58f383d83bf4",
    accountType: "SUPER_ADMIN",
    password: "",
    status: "ACTIVE",
  };

  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const { id } = useParams();
  const { t } = useTranslation();
  //breadcrumb
  const translateForm = "customersForm";
  const translateModule = "customers";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { countryFormList } = useSelector((state) => state.countryReducer);
  const { roleList } = useSelector((state) => state.roleReducer);
  const { customerDetail } = useSelector((state) => state.customerReducer);

  const handleInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  //pozvati podatke za drzave kako bi izlistali u selektu
  useEffect(() => {
    dispatch(fetchCountryFormList());
    dispatch(fetchRoleList());

    setData(initialState);
  }, []);

  useEffect(() => {
    if (!id) {
      // Ako `id` ne postoji, očisti stanje za novu kreaciju
      setData(initialState);
    } else {
      // Ako `id` postoji, učitaj podatke za korisnika
      dispatch(fetchCustomerList(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (customerDetail && id) {
      setData({
        ...data,
        name: customerDetail.name || "",
        lastName: customerDetail.lastName || "",
        email: customerDetail.email || "",
        roleId: customerDetail.roleId || initialState.roleId,
        countryId: customerDetail.countryId || initialState.countryId,
        accountType: customerDetail.accountType || initialState.accountType,
        status: customerDetail.status || initialState.status,
      });
    }
  }, [customerDetail, id]);

  const clientValidationHandler = () => {
    const { name } = data;

    let errorsObject = {};

    errorsObject = basicFormValidationHandler({
      name,
    });

    setErrors(errorsObject);

    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    return !isEmpty(errorsObject);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (clientValidationHandler()) {
      return;
    }
    if (id) {
      data.id = id;
      dispatch(updateCustomer(data, navigate));
    } else {
      dispatch(createNewCustomer(data, navigate));
    }
  };

  const handleGeneratePassword = () => {
    const newPassword = generateRandomPassword();
    setData((prevCustomer) => ({
      ...prevCustomer,
      password: newPassword,
    }));
  };

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={translateModule}
        id={id}
        extraTitle={customerDetail && customerDetail.name}
        pageType={pageType}
      />
      <Container>
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <SubmitButtonForm id={id} />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg={8}>
                  <Card>
                    <Card.Header>
                      <FormTitleMain />
                    </Card.Header>
                    <Card.Body>
                      <div className="product-holder-admin-left-side-text">
                        <Row>
                          <Col lg={4} md={12} xs={12} className="mb-3">
                            <InputField
                              label="Ime"
                              name="name"
                              value={data.name}
                              onChange={handleInputChange}
                              error={errors}
                              errorsHandler={setErrors}
                              fullWidth
                              size="small"
                              required
                            />
                          </Col>
                          <Col lg={4} md={12} xs={12} className="mb-3">
                            <InputField
                              label="Prezime"
                              name="lastName"
                              value={data.lastName}
                              onChange={handleInputChange}
                              error={errors}
                              errorsHandler={setErrors}
                              fullWidth
                              size="small"
                              required
                            />
                          </Col>
                          <Col lg={4} md={12} xs={12} className="mb-3">
                            <FormControl fullWidth>
                              <InputLabel id="demo-simple-select-label">
                                Država
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={data.countryId}
                                label="Država"
                                name="countryId"
                                onChange={handleInputChange}
                                size="small"
                              >
                                {countryFormList?.map((item, key) => (
                                  <MenuItem value={item.id} key={key}>
                                    {item.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Col>
                          <Col lg={6} md={12} xs={12} className="mb-3">
                            <InputField
                              label="Email"
                              name="email"
                              value={data.email}
                              onChange={handleInputChange}
                              error={errors}
                              errorsHandler={setErrors}
                              fullWidth
                              size="small"
                              required
                            />
                          </Col>
                          <Col lg={6} md={12} xs={12} className="mb-3">
                            <FormControl fullWidth>
                              <InputLabel id="demo-simple-select-label">
                                Vrsta naloga
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={data.accountType}
                                label="Vrsta naloga"
                                name="accountType"
                                onChange={handleInputChange}
                                size="small"
                              >
                                <MenuItem value="SUPER_ADMIN">
                                  Glavni administrator
                                </MenuItem>
                                <MenuItem value="COUNTRY_ADMIN">
                                  Administrator za državu
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </Col>
                          {/* {!id && ( */}
                          <Fragment>
                            <Col lg={12}>
                              <RibbonRow title="Sigurnosne postavke" />
                            </Col>
                            <Col lg={12} md={12} xs={12} className="mb-3">
                              <Row>
                                <Col lg={4} md={12} xs={12}>
                                  <Button
                                    className="generate-password-input w-100"
                                    variant="contained"
                                    color="primary"
                                    startIcon={<KeyIcon />}
                                    onClick={() => handleGeneratePassword()}
                                  >
                                    Generiši lozinku
                                  </Button>
                                </Col>
                                <Col lg={8} md={12} xs={12}>
                                  <InputField
                                    label="Lozinka"
                                    name="password"
                                    value={data.password}
                                    onChange={handleInputChange}
                                    error={errors}
                                    errorsHandler={setErrors}
                                    fullWidth
                                    size="small"
                                    disabled
                                    required
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Fragment>
                          {/* )} */}
                        </Row>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={4}>
                  <Row>
                    <Col lg={12}>
                      <SelectStatus
                        data={data}
                        handleInputChange={handleInputChange}
                      />
                    </Col>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>Izbor role</Card.Header>
                        <Card.Body>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Rola
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={data.roleId}
                              label="Rola"
                              name="roleId"
                              onChange={handleInputChange}
                              size="small"
                            >
                              {roleList?.map((item, key) => (
                                <MenuItem value={item.id} key={key}>
                                  {item.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Card.Body>
                      </Card>
                    </Col>
                    {id && (
                      <Col lg={12}>
                        <FormSystemInformation data={data} />
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default CustomerAdd;
